import { GenerateUrl } from "@/core/Services/GlobalFunctions";
import ApiService from "@/core/Axios/ApiService";
import ConfigurationService from "@/core/Services/ConfigurationService";
import {
  CreateNotification,
  Notifications,
  UpdateNotification,
} from "./NotificationsTypes";

export default class NotificationsService {
  async getNotifications(): Promise<Notifications[]> {
    const url = GenerateUrl({
      path: "/api/notification",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    const response = await ApiService.get(url);
    return response.data;
  }

  async createNotification(notification: CreateNotification): Promise<any> {
    const url = GenerateUrl({
      path: "/api/notification",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.post(url, notification);
  }

  async updateNotification(notification: UpdateNotification): Promise<any> {
    const url = GenerateUrl({
      path: "/api/notification",
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.put(url, notification);
  }

  async deleteNotification(id: number): Promise<any> {
    const url = GenerateUrl({
      path: `/api/notification/${id}`,
      prefixPath: ConfigurationService.configData.PARKOM_API_PREFIX_PATH,
    });
    return await ApiService.delete(url);
  }
}
